import { Breadcrumb } from 'antd'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { DotIcon } from 'src/components/CustomIcon'
import menuConfig from '../../configs/menu'
const mineRoutePath = (path, level, array) => {
	if (level > 0) {
		level--
		let newArr = []
		array.forEach((e) => {
			newArr = newArr.concat(e.subs || [])
		})

		return mineRoutePath(path, level, newArr)
	}

	if (array?.length) return array.find((e) => e.Url === path)

	return null
}

const CustomBreadcrumb = ({
	rootLabel = 'Trang chủ',
	customRoute,
	header = '',
	...optionProps
}) => {
	let router = useRouter()
	const [breadcrumbs, setBreadcrumbs] = useState([])
	const [title, setTitle] = useState('')

	useEffect(() => {
		const { asPath } = router
		const routeLevels = asPath.split('/').slice(1)

		const breadcrumbData = routeLevels.map((item, index) => {
			let currentPath =
				index > 0 ? '/' + routeLevels.slice(0, index).join('/') + `/${item}` : `/${item}`
			return mineRoutePath(currentPath, index, menuConfig.DISABLED_BREADSCRUMB)
		})

		setBreadcrumbs(
			customRoute ||
				breadcrumbData
					.filter((e) => !!e)
					.map((item) => ({
						breadcrumbName: item.Name,
						breadcrumbSubName: item.SubName,
						path: item.noRedirect ? router.asPath : item.Url,
					}))
		)
	}, [router])

	useEffect(() => {
		if (breadcrumbs[0]) setTitle(header || breadcrumbs[0].breadcrumbName.toUpperCase())
	}, [breadcrumbs])

	if (!breadcrumbs) {
		return null
	}

	if (breadcrumbs[0]?.path === '/') {
		return null
	}

	return (
		<div className="breadcrumb-path">
			<div className="headerbreadcrumb-title">
				<h1>{title}</h1>
			</div>
			<Breadcrumb
				{...optionProps}
				separator={<DotIcon style={{ transform: 'translateY(-3px)' }} />}
			>
				<Breadcrumb.Item key={rootLabel}>
					<Link href="/">
						{rootLabel}
					</Link>
				</Breadcrumb.Item>

				{breadcrumbs.length >= 1 &&
					breadcrumbs.map((breadcrumb, index) => (
						<Breadcrumb.Item key={breadcrumb.path}>
							<Link href={breadcrumb.path}>
								<a
									style={
										index == breadcrumbs.length - 1
											? { fontWeight: 600, fontFamily: 'SF Pro Display', color: '#5e6278' }
											: {}
									}
								>
									{breadcrumb.breadcrumbSubName}
								</a>
							</Link>
						</Breadcrumb.Item>
					))}
			</Breadcrumb>
		</div>
	)
}

export default CustomBreadcrumb
